import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import * as cheerio from 'cheerio';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useMediaQuery, Box, Typography, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { getPetInfobyTagId } from "../services/api";
import { convertFromISO } from "../utils/dateValidation";
import { useTranslation } from 'react-i18next';
import {
    getDogBreeds,
    getCatBreeds,
} from "../services/api";

const Info = () => {
    const [searchParams] = useSearchParams();
    const isMobile = useMediaQuery("(max-width:850px)");
    const navigate = useNavigate();
    const petTagNumber = searchParams.get('qr')
    const latitude = searchParams.get('lat') || '';
    const longitude = searchParams.get('lng') || '';
    const petId = searchParams.get('petId') || '';
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [petData, setPetData] = useState(location.state?.petData);


    const zh = i18n.language === 'zh' || i18n.language.startsWith('zh');
    const en = i18n.language === 'en' || i18n.language.startsWith('en');
    const [dogBreeds, setDogBreeds] = useState([]);
    const [catBreeds, setCatBreeds] = useState([]);
    const [carouselIndex, setCarouselIndex] = useState(0);
    
    // const loadDogBreeds = async (lang) => {
    //     try {
    //         const response = await getDogBreeds(lang);
    //         const breedsData = response.data.result || [];
    //         setDogBreeds(breedsData);
    //     } catch (err) {
    //         console.error("Error loading dog breeds:", err);
    //     }
    // };

    // const loadCatBreeds = async (lang) => {
    //     try {
    //         const response = await getCatBreeds(lang);
    //         const breedsData = response.data.result || [];
    //         setCatBreeds(breedsData);
    //     } catch (err) {
    //         console.error("Error loading cat breeds:", err);
    //     }
    // };


    // Construct Google Maps URL for the user's location
    const userLocationUrl = latitude && longitude
        ? `https://www.google.com/maps?q=${latitude},${longitude}`
        : '';

    const [petInfo, setPetInfo] = useState({
        name: "",
        birthday: "",
        sex: "",
        breedimage: [],
        sterilization: "",
        status: "",
        animal: "",
        breed: "",
        weight: "",
        features: "",
        info: "",
        owner: "",
        petNumber: "",
        ngoId: "",
        ownerContact1: "",
        ownerContact2: "",
        contact1Show: false,
        contact2Show: false,
        receivedDate: "",
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // useEffect(() => {
    //     if (petInfo.animal === "dog") {
    //         loadDogBreeds("zh");
    //     }
    //     if (petInfo.animal === "cat") {
    //         loadCatBreeds("zh");
    //     }
    // }, [petInfo.animal, i18n.language]);

    // // Helper to get breed name
    // const getBreedName = () => {
    //     if (petInfo.animal === "dog") {
    //         const breedObj = dogBreeds.find(b => b.value === petInfo.breed);
    //         return breedObj ? breedObj.label : petInfo.breed || '-';
    //     }
    //     if (petInfo.animal === "cat") {
    //         const breedObj = catBreeds.find(b => b.value === petInfo.breed);
    //         return breedObj ? breedObj.label : petInfo.breed || '-';
    //     }
    //     return '-';
    // };

    // Fetch pet data by PetNumber
    useEffect(() => {
        if (!petTagNumber) {
            setError('无效的QR码或宠物名称');
            setLoading(false);
            return;
        }
        getPetInfobyTagId(petTagNumber)
            .then((response) => {
                const petData = response.data.form;
                setPetInfo((prev) => ({
                    ...prev,
                    ...petData,
                    birthday: convertFromISO(petData.birthday),
                }));
                setLoading(false);
            })

            .catch((error) => {
                if (error.status === 404) {
                    console.log("error");
                }
                console.error("Error fetching pet data:", error);
            });
    }, [petTagNumber]);

    // 图片加载错误处理
    const handleImageError = (e) => {
        console.error('图片加载失败:', e.target.src);
        e.target.onerror = null; // 防止无限循环

        // 尝试替代URL
        const originalSrc = e.target.src;
        let newSrc = '';

        if (originalSrc.includes('pet_images')) {
            // 尝试另一种路径格式
            newSrc = originalSrc.replace('pet_images', 'images/pets');
            console.log('尝试替代URL:', newSrc);
            e.target.src = newSrc;

            // 如果替代也失败，使用默认图片
            e.target.onerror = () => {
                console.log('使用默认图片');
                e.target.src = '/icons/placeholder.png';
            };
        } else {
            e.target.src = '/icons/placeholder.png';
        }
    };

    // Facebook分享功能
    const handleShare = () => {
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
        window.open(shareUrl, '_blank', 'width=600,height=400');
    };

    // 样式定义
    const pageStyle = {
        backgroundColor: 'var(--color-background-light)',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '100px 6%',
        gap: '40px',
    };

    const outsideContainerStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: isMobile ? "100%" : "800px",
        alignItems: 'center',
    }

    const containerHeader = {
        fontSize: isMobile ? "13px" : "36px",
        fontWeight: 'bold',
        marginBottom: '20px'
    }
    const containerStyle2 = {
        display: 'flex',
        backgroundColor: 'white',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 10px',
        flexDirection: isMobile ? 'column' : null,
        width: '100%',
    }
    const insideContainer1 = {
        display: 'flex',
        flexDirection: isMobile ? 'row' : 'column',
        gap: isMobile ? '20px' : '0px',
        width: isMobile ? '100%' : '50%',
        padding: '20px',
        borderRight: isMobile ? '0px' : '2px solid grey',
        borderBottom: isMobile ? '2px solid grey' : '0px',
        fontSize: isMobile ? '13px' : '16px'
    }
    const insideContainer2 = {
        display: 'flex',
        flexDirection: isMobile ? 'row' : 'column',
        gap: isMobile ? '20px' : '0px',
        width: isMobile ? '100%' : '50%',
        padding: '20px',
        fontSize: isMobile ? '13px' : '16px'
    }

    const insideContainerHeader = {
        fontSize: isMobile ? "13px" : "23px",
        fontWeight: 'bold',
        width: isMobile ? '50%' : '100%'
    }

    const containerStyle = {
        backgroundColor: 'white',
        borderRadius: '37px 37px 0 0',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        width: '100%',
        padding: isMobile ? '15px' : '30px',
        display: 'flex',
        flexDirection: 'column',
        gap: isMobile ? '10px' : '20px',
    };

    const headerStyle = {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: isMobile ? "90%" : "98%",
    };

    const titleStyle = {
        fontSize: isMobile ? "20px" : "44px",
        fontWeight: 'bold',
    };

    const subtitleStyle = {
        fontSize: isMobile ? "13px" : "26px",
        color: '#555',
        lineHeight: '1.5',
    };

    const contentStyle = {
        display: 'flex',

    };

    const imageContainerStyle = {
        width: '50%',
        display: 'flex',
        justifyContent: 'center',
    };

    const imageStyle = {
        width: '100%',
        height: isMobile ? '100px' : '300px',
        maxHeight: isMobile ? '100px' : '300px',
        borderRadius: '8px',
        objectFit: 'contain',
    };

    const infoContainerStyle = {
        width: '50%',
        position: 'relative',
    };

    const petNameStyle = {
        fontSize: isMobile ? "30px" : "80px",
        fontWeight: 'bold',
        color: '#FFB60C',
        lineHeight: '0.75',
        marginBottom: isMobile ? '10px' : '20px',
    };

    const infoLineStyle = {
        display: 'flex',
        flexDirection: 'column',
        fontSize: isMobile ? "10px" : "16px",
        lineHeight: '1',
        gap: isMobile ? '2px' : '5px',
    };

    const infoLabelStyle = {
        fontWeight: 'bold',
        minWidth: '70px',
        marginRight: '10px',
    };

    const shareButtonStyle = {
        backgroundColor: '#1877f2', // Facebook蓝
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'fit-content',
    };

    const locationSectionStyle = {

        textAlign: 'center',
    };

    const locationLinkStyle = {
        color: 'var(--color-primary)',
        textDecoration: 'underline',

    };

    if (loading) {
        return (
            // <div style={pageStyle}>
            //     <div style={{ ...containerStyle, textAlign: 'center', padding: '50px', }}>
            //         {t('Loading')}
            //     </div>
            // </div>

            <div style={{
                backgroundColor: 'var(--color-background-light)',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh'
            }}>
                <Navbar />
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                    }}
                >
                    <Typography variant="h6" color="text.secondary">
                        <img
                            src="https://petpetclub.s3.ap-southeast-1.amazonaws.com/user-uploads/pets/68cb893a0feda12f2dbcc02b/68d4c8ce22baedfbe8b852dd.gif"
                            alt="Loading"
                            style={{
                                width: "150px",
                                height: "auto",
                                mixBlendMode: "multiply",
                            }}
                        />
                        <div
                            style={{
                                fontWeight: "500px",
                                fontSize: "15px",
                                textAlign: "center",
                                fontFamily: "Lucida Console",

                            }}>
                            {t('Loading')}
                        </div>
                    </Typography>
                </Box>
                <Footer />
            </div>
        );
    }

    if (error) {
        return (
            <div style={pageStyle}>
                <div style={{ ...containerStyle, textAlign: 'center', padding: '50px' }}>
                    <div style={{ color: 'red' }}>{error}</div>
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginTop: '20px',
                            padding: '10px 15px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                        }}
                    >
                        返回上一頁
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            backgroundColor: 'var(--color-background-light)',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh'
        }}>
            <Navbar />
            <div style={pageStyle}>
                <div style={{ display: 'flex', width: '100%' }}>
                    <div style={{ width: isMobile ? "10%" : "2%" }}>
                        <svg
                            onClick={() => petId ? navigate(`/pet-management/edit/${petData._id}`, { state: { petData } }) : navigate(`/Geolocation?qr=${petTagNumber}`)}
                            style={{ cursor: 'pointer', }}
                            onMouseOver={(e) => e.currentTarget.setAttribute('transform', 'scale(1.5)')}
                            onMouseOut={(e) => e.currentTarget.setAttribute('transform', 'scale(1)')}
                            width="14" height="28" viewBox="0 0 14 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 25.3997L2 13.6999L12 2" stroke="#050505" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <header style={headerStyle}>
                        <h1 style={titleStyle}>{t("GeolocationTitle")}</h1>
                        <p style={subtitleStyle}>
                            {t("InfoContent-1")}
                            <br></br>
                            {t("InfoContent-2")}
                        </p>
                    </header>
                </div>
                <div style={outsideContainerStyle}>
                    <div style={containerStyle}>

                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                            <div style={{ fontSize: isMobile ? "13px" : "36px", fontWeight: 'bold' }}>寵物身份證</div>
                            <div style={{ fontSize: isMobile ? "13px" : "36px", fontWeight: 'bold' }}>PET IDENTITY CARD</div>
                        </div>
                        <div style={contentStyle}>
                            <div style={imageContainerStyle}>
                                {petInfo.breedimage && petInfo.breedimage.length > 0 ? (
                                    <Box sx={{ position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        {/* Carousel Container */}
                                        <Box sx={{ position: 'relative', width: '80%', height: isMobile ? '100px' : '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', objectFit: 'contain',}}>
                                            {/* Left Arrow */}
                                            {petInfo.breedimage.length > 1 && (
                                                <IconButton
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: 8,
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 2,
                                                        background: 'rgba(255,255,255,0.7)',
                                                        '&:hover': {
                                                            background: 'rgba(255,255,255,0.9)'
                                                        }
                                                    }}
                                                    onClick={() => setCarouselIndex((prev) =>
                                                        prev === 0 ? petInfo.breedimage.length - 1 : prev - 1
                                                    )}
                                                >
                                                    <ChevronLeft />
                                                </IconButton>
                                            )}
                                            {/* Image */}
                                            <img
                                                src={petInfo.breedimage[carouselIndex]}
                                                alt={`${petInfo.name}的照片 ${carouselIndex + 1}`}
                                                style={imageStyle}
                                                onError={handleImageError}
                                            />
                                            {/* Right Arrow */}
                                            {petInfo.breedimage.length > 1 && (
                                                <IconButton
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 8,
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 2,
                                                        background: 'rgba(255,255,255,0.7)',
                                                        '&:hover': {
                                                            background: 'rgba(255,255,255,0.9)'
                                                        }
                                                    }}
                                                    onClick={() => setCarouselIndex((prev) =>
                                                        prev === petInfo.breedimage.length - 1 ? 0 : prev + 1
                                                    )}
                                                >
                                                    <ChevronRight />
                                                </IconButton>
                                            )}
                                        </Box>
                                        {/* Dots */}
                                        {petInfo.breedimage.length > 1 && (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 0.5 }}>
                                                {petInfo.breedimage.map((_, idx) => (
                                                    <Box
                                                        key={idx}
                                                        sx={{
                                                            width: 10,
                                                            height: 10,
                                                            borderRadius: '50%',
                                                            background: idx === carouselIndex ? '#FFB60C' : '#ddd',
                                                            cursor: 'pointer',
                                                            transition: 'background 0.3s ease',
                                                            '&:hover': {
                                                                background: idx === carouselIndex ? '#FFB60C' : '#bbb'
                                                            }
                                                        }}
                                                        onClick={() => setCarouselIndex(idx)}
                                                    />
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                ) : (
                                    <div style={{
                                        ...imageStyle,
                                        height: '300px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                        <img src="/icons/placeholder.png" alt="" />
                                    </div>
                                )}
                            </div>

                            <div style={infoContainerStyle}>
                                <div style={{
                                    position: 'absolute',
                                    right: '0',
                                    width: '70%',
                                    rotate: '-30deg',
                                    opacity: '0.4',
                                }}>
                                    <img src="/icons/placeholder.png" alt="" />
                                </div>
                                <h2 style={petNameStyle}>{petInfo.name || '-'}</h2>

                                <div style={{ display: 'flex', gap: '5%' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: isMobile ? "40%" : "30%", gap: isMobile ? '10px' : '20px' }}>
                                        <div style={infoLineStyle}>
                                            <span style={infoLabelStyle}>{t('DateofBirth')}</span>
                                            <span>{petInfo.birthday || '-'}</span>
                                        </div>

                                        <div style={infoLineStyle}>
                                            <span style={infoLabelStyle}>{t('Gender')}</span>
                                            <span>{petInfo.sex || '-'}</span>
                                        </div>

                                        <div style={infoLineStyle}>
                                            <span style={infoLabelStyle}>{t('Neutered')}</span>
                                            <span>{petInfo.sterilization ? 'yes' : 'no' || '-'}</span>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', width: "65%", gap: isMobile ? "10px" : '20px' }}>
                                        <div style={infoLineStyle}>
                                            <span style={infoLabelStyle}>{t('breed')}</span>
                                            <span>{petInfo.breed || '-'}</span>
                                        </div>
                                        <div style={infoLineStyle}>
                                            <span style={infoLabelStyle}>{t('weight')}</span>
                                            <span>{petInfo.weight || '-'} KG</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{
                        width: '100%',
                        backgroundColor: '#FFB60C',
                        height: isMobile ? '20px' : '40px',
                        borderRadius: '0 0 37px 37px',
                    }}></div>
                </div>

                <div style={outsideContainerStyle}>
                    <div style={containerHeader}>{t('Pet Information')}</div>
                    <div style={containerStyle2}>
                        <div style={insideContainer1}>
                            <div style={insideContainerHeader}>{t('Features')}</div>
                            <span>{petInfo.features || t('unknown')}</span>
                        </div>
                        <div style={insideContainer2}>
                            <div style={insideContainerHeader}>{t('OtherInfo')}</div>
                            <span>{petInfo.info || t('unknown')}</span>
                        </div>
                    </div>
                </div>

                <div style={outsideContainerStyle}>
                    <div style={containerHeader}>{t('ContactInfo')}</div>
                    <div style={containerStyle2}>
                        <div style={insideContainer1}>
                            <div style={insideContainerHeader}>{t('ContactPerson')}</div>
                            <span>{petInfo.owner || '未知'}</span>
                        </div>
                        <div style={insideContainer2}>
                            <div style={insideContainerHeader}>{t('ContactPhone')}</div>
                            <span>{petInfo.contact1Show ? petInfo.ownerContact1 : t('unknown')} / {petInfo.contact2Show ? petInfo.ownerContact2 || t('unknown') : t('unknown')}</span>
                        </div>
                    </div>
                </div>

                {!petId &&<div style={locationSectionStyle}>
                    <p>
                        {t('PleaseCheckIf')}{' '}
                        <a

                            href={userLocationUrl || '#'}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={locationLinkStyle}
                        >
                            {t('currentLocation')}
                        </a>{' '}
                        {t('isCorrect')}
                    </p>
                </div>}

                <button style={shareButtonStyle} onClick={handleShare}>
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="white"
                        style={{ margin: '8px' }}
                    >
                        <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm13 2h-2.5C13 5 11 7 11 9.5V11h-2v3h2v7h3v-7h2.5l.5-3h-3V9.5c0-.8.7-1.5 1.5-1.5H18V5z" />
                    </svg>
                    <div style={{ padding: '8px', borderLeft: '2px solid black' }}>{t('Share')}</div>
                </button>

            </div>
            <Footer />
        </div>
    );
};

export default Info;